@if (moeterMedforTidligBehandletProtokoll().length > 0) {
  <inline-melding type="feil">
    {{ 'Vi fant protokoller som behandles før møtet er avholdt.'|translate }}
    <ul>
      @for (innslag of moeterMedforTidligBehandletProtokoll(); track innslag.moete.id) {
        @for (sak of innslag.forTidligeProtokollbehandlinger; track sak.id) {
          <li>{{ 'Protokoll fra {pm_tittel} {pm_nummer} ({pm_dato}) saksbehandles i {bm_tittel} {bm_nummer} ({bm_dato})'|translate:
                  {pm_tittel: innslag.moete.tittel,
                    pm_nummer: innslag.moete.nummer,
                    pm_dato: innslag.moete.dato.start|zoneddatetimeSomPlaindate|plaindate,
                    bm_tittel: sak.moete.tittel,
                    bm_nummer: sak.moete.nummer,
                    bm_dato: sak.moete.dato.start|zoneddatetimeSomPlaindate|plaindate,
                  } }}</li>
        }
      }
    </ul>
    {{ 'Vi anbefaler at du flytter saken med protokollen til et senere møte.'|translate }}
    {{ 'Se hvordan her:'|translate }}
    <a href="{{eksterneLenker.hjelpesider.flyttProtokoll}}" target="_blank">{{ 'Flytte en sak til et annet møte.'|translate }}</a>
  </inline-melding>
}

@if (moeter().length > 0 || laster()) {
  <table class="møter">
    <thead>
    <tr>
      <th class="møte">{{ 'Møte'|translate }}</th>
      <th class="status">{{ 'Protokollstatus'|translate }}</th>
      <th class="handlinger"></th>
      <th class="behandlinger">{{ 'Protokollen behandles i'|translate }}</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
      @for (innslag of moeter(); track innslag.moete.id) {
        <tr>
          <td class="møte">
            <a (click)="gaaTilProtokoll(innslag)">
              <moete-kortvisning-mini [moete]="innslag.moete" datoformat="langt"
                                      matTooltip="{{'Gå til protokollen for dette møtet'|translate}}"/>
            </a>
          </td>
          <td class="status">
            <moeteprotokoll-status [moete]="innslag.moete"/>
          </td>
          <td class="handlinger">
            <button mat-icon-button class="mat-medium-icon-button" (click)="lastNedProtokoll(innslag)"
                    matTooltip="{{'Last ned protokollen til din maskin'|translate}}" matTooltipPosition="after">
              <mat-icon>download</mat-icon>
            </button>
            <button mat-icon-button class="mat-medium-icon-button" (click)="aapneForhaandsvisningProtokoll(innslag)"
                    matTooltip="{{'Se på protokollen i PDF-format'|translate}}" matTooltipPosition="after">
              <mat-icon fontSet="ion-ios-eye-outline" class="mat-icon--ionic-ikon"/>
            </button>
          </td>
          <td class="behandlinger">
            @if (innslag.protokollBehandlesI.length > 0) {
              <ul>
                @for (sak of innslag.forTidligeProtokollbehandlinger; track sak.id) {
                  <li class="for-tidlig">
                    <a (click)="gaaTilBehandling(sak)">
                      <mat-icon inline="true" class="advarsel"
                                matTooltip="{{'Protokollen behandles før møtet den gjelder for er avholdt'|translate}}">warning
                      </mat-icon>
                      <span matTooltip="{{'Gå til denne behandlingen av protokollen'|translate}}">
                        {{ '{moete} {moetenummer} ({dato}), i sak {saksnummer} {sakstittel}'|translate: {moete: sak.moete.tittel, moetenummer: sak.moete.nummer, dato: sak.moete.dato.start|zoneddatetimeSomPlaindate|plaindate, saksnummer: sak.nummer, sakstittel: sak.tittel} }}
                      </span>
                      <mat-icon inline="true">arrow_forward</mat-icon>
                    </a>
                  </li>
                }
                @for (sak of innslag.paafoelgendeProtokollbehandlinger; track sak.id) {
                  <li>
                    <a (click)="gaaTilBehandling(sak)"
                       matTooltip="{{'Gå til denne behandlingen av protokollen'|translate}}">
                      {{ '{moete} {moetenummer} ({dato}), i sak {saksnummer} {sakstittel}'|translate: {moete: sak.moete.tittel, moetenummer: sak.moete.nummer, dato: sak.moete.dato.start|zoneddatetimeSomPlaindate|plaindate, saksnummer: sak.nummer, sakstittel: sak.tittel} }}
                      <mat-icon inline="true">arrow_forward</mat-icon>
                    </a>
                  </li>
                }
              </ul>
            } @else {
              <span class="ingen-behandlinger">{{ 'Protokollen er ikke til behandling i noe møte'|translate }}</span>
            }
          </td>
          <td class="meny"></td>
        </tr>
      }
    </tbody>
    @if (!laster()) {
      <tfoot>
      <tr>
        <td></td>
        <td></td>
        <td class="handlinger" colspan="2">
          <button mat-button (click)="visEksporterDialog()">
            <mat-icon>download</mat-icon>
            {{ 'Last ned protokoller'|translate }}
          </button>
        </td>
        <td></td>
      </tr>
      </tfoot>
    }
  </table>
} @else {
  <tips>{{ 'Ingen møter registret i {periode}'|translate: {periode: periodetittel()} }}</tips>
}

<!--Skjema for valg av møter/protokoller for eksport-->
<ng-template #eksportDialogTemplate>
  <div class="eksport-dialog">
    <h2 mat-dialog-title>{{ "Eksporter protokoller"|translate }}</h2>
    <mat-dialog-content class="skjema">
      <p>{{ 'Last ned valgte protokoller som en zip-fil til din maskin.'|translate }}</p>
      <mat-form-field class="velg-møter">
        <mat-label>{{ 'Velg hvilke møter du vil eksportere protokoll fra'|translate }}</mat-label>
        <mat-select [formControl]="valgteMoeterKontroller" [compareWith]="erValgt" multiple="true">
          <mat-select-trigger>
            {{ '{antall} møter valgt'|translate: {antall: valgteMoeterKontroller.value.length} }}
          </mat-select-trigger>
          @for (innslag of moeter(); track innslag.moete.id) {
            <mat-option [value]="innslag">{{ innslag.moete.tittel }} {{ innslag.moete.nummer }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
      <button mat-button (click)="avbrytEksporter()">{{ "Avbryt"|translate }}</button>
      <button mat-raised-button color="primary" (click)="eksporter()" [disabled]="valgteMoeterKontroller.invalid"
              cdkFocusInitial>{{ "Eksporter"|translate }}
      </button>
    </mat-dialog-actions>
  </div>
</ng-template>
